import {useEffect} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {useLocation, useNavigate} from "react-router-dom";
// import useNotifications from "@/hooks/templates.ts";
import useLoans from "@/hooks/loans.ts";
import useAuth from "@/hooks/auth.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import {useAtom} from "jotai/index";
import {contract, notificationsList, popping_notifications} from "@/atoms/common.ts";
import {notificationType} from "@/types_and_interfaces/types.ts";
import SnackbarNotificationInterface from "@/types_and_interfaces/snackbar_notification_interface.ts";
import NotificationInterface from "@/types_and_interfaces/notification_interface.ts";

const EventListeners = () => {
    const navigate = useNavigate()
    // const notif_hook = useNotifications()
    const loans = useLoans()
    const [, setNotifications] = useAtom(notificationsList)
    const [, setPoppingNotifications] = useAtom(popping_notifications)
    const [, set_contract] = useAtom(contract)
    const auth = useAuth()
    const location  = useLocation()
    
    const nav_to = (x:string) => {
        if (x === DashboardClass.dashboard_routes.Home) {
            const sw_pending = sessionStorage.getItem('sw_pending_redirect')

            if (sw_pending) {
                sessionStorage.removeItem('sw_pending_redirect')
                navigate(sw_pending)
                return
            }
        }

        let apply_credit_form = sessionStorage.getItem(CommonClass.local_storage_fields.apply_credit_form_body)

        if(x === DashboardClass.dashboard_routes.Home && apply_credit_form !== null) {
            localStorage.setItem(CommonClass.local_storage_fields.before_apply_cr, DashboardClass.dashboard_routes.Home)
            navigate(DashboardClass.dashboard_routes.ApplyCredit)

            return
        }

        navigate(x)
    }
    
    const updateSnackbar = (type: notificationType, message:string, btn_text?:string, funct?: () => void) => {
        
        if(type && message) {
            let item:SnackbarNotificationInterface = {
                message,
                type,
                btn_text,
                funct
            }
            
            setNotifications((notifications) => [...notifications, ...[item]])
        }
    }
    
    const updatePoppingNotifications = (obj:NotificationInterface) => {
        setPoppingNotifications((notifications) => [...notifications, ...[obj]])
    }
    
    const removeSnackbar = (nr:number) => {
        if(typeof nr === "undefined") return
        
        setNotifications((notifications) =>
            notifications.filter((_item, i) => i !== nr)
        );
    }
    
    
    const add_notif_modal_handler = (event:any) => {
        if(import.meta.env.MODE === 'development') {
            if ((event.ctrlKey || event.metaKey) && event.key === 'q') {
                event.preventDefault();
                eventEmitter.emit(CommonClass.ModalEvents.OpenAddNotifModal, true)
            }
        }
    };
    
    const remove_contract = () => {
        set_contract({})
    }

    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const sw_redirect = urlParams.get('sw_redirect')
        if (sw_redirect) {
            sessionStorage.setItem('sw_pending_redirect', sw_redirect)
        }

        const sw_navigate_handler = (event: MessageEvent) => {
            if (event.data?.type === 'SW_NAVIGATE' && event.data?.url) {
                sessionStorage.setItem('sw_pending_redirect', event.data.url)
                navigate(event.data.url, event.data?.loan_id ? { state: { loan_id: event.data.loan_id } } : undefined)
            }
        }

        eventEmitter.on(CommonClass.CustomEvents.redirect_to, nav_to)
        // eventEmitter.on(CommonClass.CustomEvents.upd_notifications, notif_hook.updateUserNotifications)
        eventEmitter.on(CommonClass.CustomEvents.upd_loans, loans.updateUserLoans)
        eventEmitter.on(CommonClass.CustomEvents.logout, auth.logOut)
        eventEmitter.on(CommonClass.CustomEvents.update_snackbar, updateSnackbar)
        eventEmitter.on(CommonClass.CustomEvents.update_popping_notifications, updatePoppingNotifications)
        eventEmitter.on(CommonClass.CustomEvents.remove_snackbar, removeSnackbar)
        eventEmitter.on(CommonClass.CustomEvents.remove_contract, remove_contract)
        window.addEventListener('keydown', add_notif_modal_handler);
        navigator.serviceWorker?.addEventListener('message', sw_navigate_handler);

        return () => {
            eventEmitter.off(CommonClass.CustomEvents.redirect_to, nav_to)
            // eventEmitter.off(CommonClass.CustomEvents.upd_notifications, notif_hook.updateUserNotifications)
            eventEmitter.off(CommonClass.CustomEvents.upd_loans, loans.updateUserLoans)
            eventEmitter.off(CommonClass.CustomEvents.logout, auth.logOut)
            eventEmitter.off(CommonClass.CustomEvents.update_snackbar, updateSnackbar)
            eventEmitter.off(CommonClass.CustomEvents.update_popping_notifications, updatePoppingNotifications)
            eventEmitter.off(CommonClass.CustomEvents.remove_snackbar, removeSnackbar)
            eventEmitter.off(CommonClass.CustomEvents.remove_contract, remove_contract)
            window.removeEventListener('keydown', add_notif_modal_handler);
            navigator.serviceWorker?.removeEventListener('message', sw_navigate_handler);
        };

    }, []);
    
    useEffect(() => {
        eventEmitter.emit(CommonClass.CustomEvents.reset_pwd_value)
        eventEmitter.emit(CommonClass.CustomEvents.reset_otp_value)
    }, [location]);


    return null
}

export default EventListeners